<template>
    
        <!-- 登录与后台共同 -->
        <!-- 根组件路由占位, 将来通过url来控制页面的展示 -->
        <router-view></router-view>
      
    
</template>

<script>
// import axios from "axios";
// import api,{ domain } from "../js/api.js";

export default {
  data() {
    return {
       
    };
  },
};
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/component/App.vue